import { render, staticRenderFns } from "./ProductClassifyBase.vue?vue&type=template&id=4e3c5ab8&scoped=true&"
import script from "./ProductClassifyBase.vue?vue&type=script&lang=js&"
export * from "./ProductClassifyBase.vue?vue&type=script&lang=js&"
import style0 from "./ProductClassifyBase.vue?vue&type=style&index=0&id=4e3c5ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c5ab8",
  null
  
)

export default component.exports